"use client";

import { AlertTriangle } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import * as m from "@/paraglide/messages";

export default function Maintenance() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle className="flex items-center space-x-2 text-warning text-2xl">
            <AlertTriangle className="h-6 w-6" />
            <span>{m.tense_tame_hamster_shine()}</span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-lg mb-4">{m.alive_full_starfish_arise()}</p>
          {/* <p className="text-muted-foreground">{m.sea_teary_puffin_dash()}</p>
          <p className="text-xl font-semibold">October 2, 2024, 19:00:00</p> */}
        </CardContent>
        <CardFooter className="flex flex-col items-start space-y-2">
          <p className="text-sm text-muted-foreground">
            {m.mealy_fun_baboon_tap()}
          </p>
          <Button
            variant="outline"
            onClick={() => {
              window.open("mailto:contact@aryatrading.com");
            }}
          >
            {m.mild_grassy_deer_roam()}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
